/**
 * useMonthNavigation
 *
 * 월 이동 기능을 제공하는 커스텀 hook
 */

import { useState, useCallback } from 'react'

interface UseMonthNavigationReturn {
  currentMonth: string // YYYY-MM 형식
  year: number
  month: number
  goToPrevMonth: () => void
  goToNextMonth: () => void
  goToMonth: (year: number, month: number) => void
}

export function useMonthNavigation(initialYear?: number, initialMonth?: number): UseMonthNavigationReturn {
  // 초기 월 설정 (기본값: 현재 월)
  const now = new Date()
  const [year, setYear] = useState(initialYear ?? now.getFullYear())
  const [month, setMonth] = useState(initialMonth ?? now.getMonth() + 1) // 1-12

  // YYYY-MM 형식 문자열
  const currentMonth = `${year}-${String(month).padStart(2, '0')}`

  // 이전 달로 이동
  const goToPrevMonth = useCallback(() => {
    if (month === 1) {
      setYear(year - 1)
      setMonth(12)
    } else {
      setMonth(month - 1)
    }
  }, [year, month])

  // 다음 달로 이동
  const goToNextMonth = useCallback(() => {
    if (month === 12) {
      setYear(year + 1)
      setMonth(1)
    } else {
      setMonth(month + 1)
    }
  }, [year, month])

  // 특정 월로 이동
  const goToMonth = useCallback((newYear: number, newMonth: number) => {
    setYear(newYear)
    setMonth(newMonth)
  }, [])

  return {
    currentMonth,
    year,
    month,
    goToPrevMonth,
    goToNextMonth,
    goToMonth,
  }
}
